module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-container"
  }, [_c('div', {
    staticClass: "inner-display"
  }, _vm._l((_vm.$store.state.catagories), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "choose-container",
      staticStyle: {
        "margin": "1rem"
      },
      on: {
        "click": function($event) {
          return _vm.routeToCollection('view-collection', item._id, item.title)
        }
      }
    }, [_c('v-img', {
      staticClass: "grey lighten-2 collection-image",
      attrs: {
        "src": item.imageUrl,
        "lazy-src": item.imageUrl,
        "aspect-ratio": "1"
      },
      scopedSlots: _vm._u([{
        key: "placeholder",
        fn: function() {
          return [_c('v-layout', {
            attrs: {
              "fill-height": "",
              "align-center": "",
              "justify-center": "",
              "ma-0": ""
            }
          }, [_c('v-progress-circular', {
            attrs: {
              "indeterminate": "",
              "color": "grey lighten-5"
            }
          })], 1)]
        },
        proxy: true
      }], null, true)
    }), _vm._v(" "), _c('div', [_c('h3', {
      staticStyle: {
        "font-family": "'DINPro Regular'"
      },
      attrs: {
        "center": ""
      }
    }, [_vm._v(_vm._s(item.title))])])], 1)
  }), 0), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "allText",
      "center": ""
    },
    on: {
      "click": function($event) {
        return _vm.routeToCollection('view-collection', 'all')
      }
    }
  }, [_vm._v("All")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f99347b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/ChooseCollection.vue
// module id = 218
// module chunks = 1